import { render, staticRenderFns } from "./dtp-single-query.vue?vue&type=template&id=2078c4f4&scoped=true"
import script from "./dtp-single-query.vue?vue&type=script&lang=js"
export * from "./dtp-single-query.vue?vue&type=script&lang=js"
import style0 from "./dtp-single-query.vue?vue&type=style&index=0&id=2078c4f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2078c4f4",
  null
  
)

export default component.exports